import type { SquawkSeverity } from './types';

// Single source of truth for how squawk severity reads to a human.
//
// The stored value stays `should_fix_soon` for every existing record — only the
// display text changed to "Advisory". Never render the raw enum: it leaks
// database casing into the UI ("SHOULD FIX SOON") and into owner emails.
//
// Labels answer the pilot's question — can I fly it, and what must I do? — not
// when maintenance should happen. functions/index.js keeps a mirrored copy for
// notification emails; update both together.
export const SQUAWK_SEV_LABEL: Record<SquawkSeverity, string> = {
  informational: 'Informational',
  should_fix_soon: 'Advisory',
  grounding: 'Grounding',
};

export const SQUAWK_SEV_DESC: Record<SquawkSeverity, string> = {
  informational: 'Cosmetic or minor wear. Nothing to do.',
  should_fix_soon: 'Aircraft is airworthy. Fly it, but know about this.',
  grounding: 'Do not fly. Aircraft is unsafe or unairworthy.',
};

// Worst first, for sorting the open list.
export const SQUAWK_SEV_RANK: Record<SquawkSeverity, number> = {
  grounding: 0,
  should_fix_soon: 1,
  informational: 2,
};
